import { apiCall } from "../../../utils/api.utils";
import { API_URLS } from "../../../constants/apiUrls";

export const cardStatementService = {
    getCardStatement,
};

function getCardStatement(cardPan, data) {
    return apiCall("POST", `${API_URLS.CARD_MANAGEMENT.GET_CARD_STATEMENT}/${cardPan}`, null, data);
}
